import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MailSummary } from '../models/mail-summary.model';
import { MailHistory } from '../models/mail-history.model';
import { MailStatutCode, MailStatutLibelle } from '../models/mail-statuts.model';

@Injectable({
    providedIn: 'root'
})
export class SuiviEmailsService {
    private readonly API_URL = '/api/mail/private';
    private readonly http = inject(HttpClient);

    private readonly MOCK_MAILS: MailSummary[] = [
        {
            id: 1,
            date: new Date('2024-04-20T10:00:00'),
            destinataire: 'jean.dupont@example.com',
            objet: 'Convocation commission',
            dernierStatutCode: MailStatutCode.DELIVERED
        },
        {
            id: 2,
            date: new Date('2024-04-21T14:30:00'),
            destinataire: 'marie.martin@test.fr',
            objet: 'Rappel documents',
            dernierStatutCode: MailStatutCode.REQUEST
        },
        {
            id: 3,
            date: new Date('2024-04-22T09:15:00'),
            destinataire: 'pierre.durand@bacchus.io',
            objet: 'Confirmation inscription',
            dernierStatutCode: MailStatutCode.ERROR
        }
    ];

    private readonly MOCK_HISTORY: Record<number, MailHistory> = {
        1: {
            id: 1,
            destinataire: 'jean.dupont@example.com',
            objet: 'Convocation commission',
            statuts: [
                { code: MailStatutCode.DEFERRED, libelle: MailStatutLibelle[MailStatutCode.DEFERRED], date: new Date('2024-04-20T10:00:00') },
                { code: MailStatutCode.DELIVERED, libelle: MailStatutLibelle[MailStatutCode.DELIVERED], date: new Date('2024-04-20T10:00:05') }
            ]
        },
        2: {
            id: 2,
            destinataire: 'marie.martin@test.fr',
            objet: 'Rappel documents',
            statuts: [
                { code: MailStatutCode.REQUEST, libelle: MailStatutLibelle[MailStatutCode.REQUEST], date: new Date('2024-04-21T14:30:00') },
                { code: MailStatutCode.DELIVERED, libelle: MailStatutLibelle[MailStatutCode.DELIVERED], date: new Date('2024-04-21T14:30:05') },
                { code: MailStatutCode.BLOCKED, libelle: MailStatutLibelle[MailStatutCode.BLOCKED], date: new Date('2024-04-20T15:00:00') }
            ]
        },
        3: {
            id: 3,
            destinataire: 'pierre.durand@bacchus.io',
            objet: 'Confirmation inscription',
            statuts: [
                { code: MailStatutCode.SPAM, libelle: MailStatutLibelle[MailStatutCode.SPAM], date: new Date('2024-04-22T09:15:00') },
                { code: MailStatutCode.ERROR, libelle: MailStatutLibelle[MailStatutCode.ERROR], date: new Date('2024-04-22T09:15:10') }
            ]
        }
    };

    /**
     * Récupère la liste des mails pour les intervenants spécifiés
     * @param idsIntervenant - Liste des ids des intervenants
     */
    getMailsByIntervenants(idsIntervenant: number[]): Observable<MailSummary[]> {
        return this.http.post<MailSummary[]>(`${this.API_URL}/intervenants`, idsIntervenant);
        
    }

    /**
     * Récupère l'historique d'un mail
     * @param idMail - Id du mail
     */
    getMailHistory(idMail: number): Observable<MailHistory> {
        return this.http.get<MailHistory>(`${this.API_URL}/${idMail}/history`);
    }
}
